import React, { useState } from 'react';
import styled from 'styled-components';

export const Label = styled.label`
input:checked + & {
background-color: ${props => props.color || '#FFFFFF'};
color: #000;
font-size: 120%;
}
`
export const Option = styled.option`
font-family: sans-serif;
font-size: 1.2rem;
`

export const Optgroup = styled.optgroup`
font-family: sans-serif;
`
